module.exports = __webpack_public_path__ + "img/nav-about.edbef55.webp";